const Locales = {
  // name of the default locale configured in Storyblok
  defaultSbLocale: "",
  sbLocaleDe: "",

  // This is used by Storyblok in field values and other cases. Why???
  defaultSbLocaleSpecialCases: "default",

  // Important: if a storyblok language contains only one part e.g. "de", "en" in the ub-language both sides (country and language) have to be the same.
  ubLocales: [
    "de-at",
    "de-ch",
    "de",
    "fr-ch",
    "fr-be",
    "nl-be",
    "nl",
    "nl-nl",
    "fr",
    "fr-fr",
    "it",
    "it-it",
    "en",
    "en-en",
  ],

  //  udobaer string locale(country - language) of the default Storyblok locale
  defaultUbLocaleForDefaultSbLocale: "de-de",

  sbLocaleToIsoLocale: {
    "de-at": "de-AT",
    "de-ch": "de-CH",
    "fr-ch": "fr-CH",
    "nl-be": "nl-BE",
    "fr-be": "fr-BE",
    nl: "nl-NL",
    it: "it-IT",
    fr: "fr-FR",
    en: "en-US",
    "": "de-DE",
  },

  isoLocaleToSbLocale: {
    "de-AT": "de-at",
    "de-CH": "de-ch",
    "fr-CH": "fr-ch",
    "nl-NL": "nl",
    "nl-BE": "nl-be",
    "fr-BE": "fr-be",
    "it-IT": "it",
    "fr-FR": "fr",
    "en-US": "en",
    "de-DE": "",
  },

  isoLocaleToCity: {
    "de-AT": "Wien",
    "de-CH": "Bern",
    "fr-CH": "Berne",
    "nl-NL": "Amsterdam",
    "nl-BE": "Brussel",
    "fr-BE": "Bruxelles",
    "it-IT": "Roma",
    "fr-FR": "Paris",
    "de-DE": "Berlin",
    "en-US": "Bruxelles",
  },

  sbLocaleToUbLocale: {
    "de-at": "at-de",
    "de-ch": "ch-de",
    "fr-ch": "ch-fr",
    nl: "nl-nl",
    "nl-be": "be-nl",
    "fr-be": "be-fr",
    fr: "fr-fr",
    it: "it-it",
    en: "en-en",
    "": "de-de",
  },

  sbLocaleToIntershopLocale: {
    // Intershop Sites are configured to only use these languages (no country specifics):
    "de-at": "de_DE",
    "de-ch": "de_DE",
    nl: "nl_NL",
    "nl-be": "nl_NL",
    "fr-be": "fr_FR",
    it: "it_IT",
    fr: "fr_FR",
    en: "en_US",
    "fr-ch": "fr_FR",
    "": "de_DE",
  },

  // this is the semantic of "default locale" in StoryBlok when the locale is empty ("")
  shortLocaleForDefaultSbLocale: "de",

  // see also url-scheme.js
  sbLocaleToDomain: {
    "de-at": "udobaer.at",
    "de-ch": "udobaer.ch",
    "fr-ch": "udobaer.ch",
    nl: "udobaer.nl",
    "nl-be": "udobaer.be",
    "fr-be": "udobaer.be",
    it: "udobaer.it",
    fr: "udobaer.fr",
    en: "udobaer.eu",
    "": "udobaer.de",
  },
}

module.exports = {
  Locales,
}
